module.exports = __webpack_public_path__ + "img/logo_white.305ef655.svg";